import { render, staticRenderFns } from "./Potential-Vip.vue?vue&type=template&id=49ff6efc&"
import script from "./Potential-Vip.vue?vue&type=script&lang=js&"
export * from "./Potential-Vip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports